import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { DangerouslySetInnerHTML } from '@infl-ts/ui-advocate-components';
import { Box, styled } from '@mui/material';
import ReactAspectRatio from 'react-aspect-ratio';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ChallengeImage = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: inherit;\n  object-fit: cover;\n"])));

var FirstStageInfo = function FirstStageInfo(_ref) {
  var _ref$challenge = _ref.challenge,
      banner = _ref$challenge.banner,
      hideBannerImage = _ref$challenge.hideBannerImage,
      description = _ref$challenge.description;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(banner === null || banner === void 0 ? void 0 : banner.url) && !hideBannerImage && /*#__PURE__*/_jsx(ReactAspectRatio, {
      ratio: "1.78",
      style: {
        width: '100%',
        marginBottom: '32px'
      },
      children: /*#__PURE__*/_jsx(ChallengeImage, {
        src: banner.url
      })
    }), description && /*#__PURE__*/_jsx(Box, {
      sx: {
        width: 1,
        mb: 5,
        display: 'flex',
        justifyContent: 'center'
      },
      children: /*#__PURE__*/_jsx(DangerouslySetInnerHTML, {
        sx: {
          width: 1
        },
        body: description
      })
    })]
  });
};

export default FirstStageInfo;